// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Stack,
//   Box,
//   Typography,
//   Skeleton,
//   CircularProgress,
//   Pagination,
// } from "@mui/material";
// import { CSVLink } from "react-csv";
// import axios from "axios";
// import GetAppIcon from "@mui/icons-material/GetApp";
// import { useAuth } from "../context/Authcontext";
// import NoAccess from "./NoAccess.jsx";
// import { fetchAllBookings } from "../api/api.js";
// const Booking = () => {
//   const [podsData, setPodsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [verifying, setVerifying] = useState(true);
//   const [userVerified, setUserVerified] = useState(false);
//   const { verifyUser } = useAuth();
//   const [page, setPage] = useState(1);
//   const itemsPerPage = 10; // Number of items per page
// console.log("podsData", podsData);
//  const loadBookingsData = async () => {
//    try {
//      const data = await fetchAllBookings();
//      const sortedData = data.sort(
//        (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
//      );
//      setPodsData(sortedData);
//      setLoading(false);
//    } catch (error) {
//      console.error("Error fetching data: ", error);
//      setLoading(false);
//    }
//  };
  
//   useEffect(() => {
//     const effect = async () => {
//       setVerifying(true);
//       let res = await verifyUser(6);
//       setUserVerified(res);
//       setVerifying(false);
//       if (res) {
//         loadBookingsData();
//       }
//     };
//     effect();
//   }, []);

//   const formatDate = (dateString) => {
//     const options = { year: "numeric", month: "2-digit", day: "2-digit" };
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-CA", options);
//   };

//   // const formatTime = (dateString) => {
//   //   const options = { hour: "2-digit", minute: "2-digit" };
//   //   const date = new Date(dateString);
//   //   return date.toLocaleTimeString("en-GB", options);
//   // };
//   // const formatTime = (dateString) => {
//   //   const options = { hour: "2-digit", minute: "2-digit", hour12: false };
//   //   const date = new Date(dateString);
//   //   return date.toISOString().slice(11, 16); // Extract time from ISO string (HH:MM format)
//   // };
//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     let hours = date.getUTCHours();
//     let minutes = date.getUTCMinutes();
//     const ampm = hours >= 12 ? "PM" : "AM";

//     // Convert to 12-hour format
//     hours = hours % 12;
//     hours = hours ? hours : 12; // 12-hour format requires hour 0 to be 12
//     minutes = minutes < 10 ? "0" + minutes : minutes;

//     return `${hours}:${minutes} ${ampm}`;
//   };



//   const headers = [
//     { label: "Booking Id", key: "podId" },
//     { label: "Booking Date", key: "bookingDate" },
//     { label: "Booking Purpose", key: "bookingPurpose" },
//     { label: "Start Time", key: "startTime" },
//     { label: "End Time", key: "endTime" },
//     { label: "Status", key: "status" },
//   ];

//   const csvReport = {
//     filename: "User_Bookings_Report.csv",
//     headers: headers,
//     data: podsData,
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//   };

//   const displayedBookings = podsData.slice(
//     (page - 1) * itemsPerPage,
//     page * itemsPerPage
//   );

//   if (verifying) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (!userVerified) {
//     return <NoAccess />;
//   } else {
//     return (
//       <Box sx={{ padding: "43px 5px" }}>
//         <Typography
//           variant="h5"
//           fontWeight={"bold"}
//           sx={{ marginBottom: 2, color: "#ED3327" }}
//         >
//           Bookings
//         </Typography>
//         <Stack justifyContent={"space-between"} direction={"row"}>
//           <Stack direction={"row"}>
//             <Button
//               variant="contained"
//               sx={{
//                 marginRight: 2,
//                 backgroundColor: "#ED3327",
//                 borderRadius: "20px",
//                 "&:hover": {
//                   bgcolor: "#ED3327",
//                 },
//               }}
//             >
//               All Bookings ({podsData.length})
//             </Button>
//           </Stack>
//           <Stack direction={"row"} spacing={2}>
//             <CSVLink {...csvReport} style={{ textDecoration: "none" }}>
//               <Button variant="outlined" startIcon={<GetAppIcon />}>
//                 Download All
//               </Button>
//             </CSVLink>
//           </Stack>
//         </Stack>
//         <TableContainer component={Paper} sx={{ marginTop: 2 }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Booking Id</TableCell>
//                 <TableCell>Booking Date</TableCell>
//                 <TableCell>Booking Purpose</TableCell>
//                 <TableCell>Booking Time</TableCell>
//                 <TableCell>Status</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading
//                 ? [1, 2, 3, 4, 5].map((n) => (
//                     <TableRow key={n}>
//                       <TableCell>
//                         <Skeleton />
//                       </TableCell>
//                       <TableCell>
//                         <Skeleton />
//                       </TableCell>
//                       <TableCell>
//                         <Skeleton />
//                       </TableCell>
//                       <TableCell>
//                         <Skeleton />
//                       </TableCell>
//                       <TableCell>
//                         <Skeleton />
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 : displayedBookings.map((pod) => (
//                     <TableRow key={pod._id}>
//                       <TableCell>{pod.podId}</TableCell>
//                       <TableCell>{formatDate(pod.bookingDate)}</TableCell>
//                       <TableCell>{pod.bookingPurpose || "N/A"}</TableCell>
//                       <TableCell>{`${formatTime(pod.startTime)} - ${formatTime(
//                         pod.endTime
//                       )}`}</TableCell>
//                       <TableCell>
//                         <Button
//                           variant="contained"
//                           color={
//                             pod.status === "Completed"
//                               ? "success"
//                               : pod.status === "Pending"
//                               ? "primary"
//                               : pod.status === "Processing"
//                               ? "warning"
//                               : "error"
//                           }
//                           sx={{ borderRadius: "20px" }}
//                         >
//                           {pod.status}
//                         </Button>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
//           <Pagination
//             count={Math.ceil(podsData.length / itemsPerPage)}
//             page={page}
//             onChange={handlePageChange}
//             variant="outlined"
//             shape="rounded"
//           />
//         </Box>
//       </Box>
//     );
//   }
// };

// export default Booking;






// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Stack,
//   Box,
//   Typography,
//   Skeleton,
//   CircularProgress,
//   Pagination,
// } from "@mui/material";
// import { CSVLink } from "react-csv";
// import GetAppIcon from "@mui/icons-material/GetApp";
// import { useAuth } from "../context/Authcontext";
// import NoAccess from "./NoAccess.jsx";
// import { fetchAllBookings, fetchLocationById, fetchUserById } from "../api/api.js"; // Import fetchLocationById
// const Booking = () => {
//   const [podsData, setPodsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [verifying, setVerifying] = useState(true);
//   const [userVerified, setUserVerified] = useState(false);
//   const { verifyUser } = useAuth();
//   const [page, setPage] = useState(1);
//   const itemsPerPage = 10; // Number of items per page

//   const loadBookingsData = async () => {
//     try {
//       const data = await fetchAllBookings();
//       const sortedData = data.sort(
//         (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//       );
//       for (const pod of sortedData) {
//         const locationData = await fetchLocationById(pod.location);
//         console.log("pod", pod);
//         console.log("locationData", locationData);
//         pod.locationDetails = locationData; 
        
//         const userData = await fetchUserById(pod.user);
//         pod.userDetails = userData;
//       }
//       setPodsData(sortedData);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data: ", error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const effect = async () => {
//       setVerifying(true);
//       let res = await verifyUser(6);
//       setUserVerified(res);
//       setVerifying(false);
//       if (res) {
//         loadBookingsData();
//       }
//     };
//     effect();
//   }, []);

//   const formatDate = (dateString) => {
//     const options = { year: "numeric", month: "2-digit", day: "2-digit" };
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-CA", options);
//   };

//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     let hours = date.getUTCHours();
//     let minutes = date.getUTCMinutes();
//     const ampm = hours >= 12 ? "PM" : "AM";

//     // Convert to 12-hour format
//     hours = hours % 12;
//     hours = hours ? hours : 12; // 12-hour format requires hour 0 to be 12
//     minutes = minutes < 10 ? "0" + minutes : minutes;

//     return `${hours}:${minutes} ${ampm}`;
//   };

//   const headers = [
//     { label: "Booking Id", key: "podId" },
//     { label: "Booking Date", key: "bookingDate" },
//     { label: "Booking Purpose", key: "bookingPurpose" },
//     { label: "Start Time", key: "startTime" },
//     { label: "End Time", key: "endTime" },
//     { label: "Status", key: "status" },
//     { label: "Location", key: "locationDetails.locationName" }, // Add location to CSV headers
//     { label: "User Name", key: "userDetails.username" },
//   ];

//   const csvReport = {
//     filename: "User_Bookings_Report.csv",
//     headers: headers,
//     data: podsData,
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//   };

//   const displayedBookings = podsData.slice(
//     (page - 1) * itemsPerPage,
//     page * itemsPerPage
//   );
// console.log("displayedBookings", displayedBookings);
//   if (verifying) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (!userVerified) {
//     return <NoAccess />;
//   } else {
//     return (
//       <Box sx={{ padding: "43px 5px" }}>
//         <Typography
//           variant="h5"
//           fontWeight={"bold"}
//           sx={{ marginBottom: 2, color: "#ED3327" }}
//         >
//           Bookings
//         </Typography>
//         <Stack justifyContent={"space-between"} direction={"row"}>
//           <Stack direction={"row"}>
//             <Button
//               variant="contained"
//               sx={{
//                 marginRight: 2,
//                 backgroundColor: "#ED3327",
//                 borderRadius: "20px",
//                 "&:hover": {
//                   bgcolor: "#ED3327",
//                 },
//               }}
//             >
//               All Bookings ({podsData.length})
//             </Button>
//           </Stack>
//           <Stack direction={"row"} spacing={2}>
//             <CSVLink {...csvReport} style={{ textDecoration: "none" }}>
//               <Button variant="outlined" startIcon={<GetAppIcon />}>
//                 Download All
//               </Button>
//             </CSVLink>
//           </Stack>
//         </Stack>
//         <Box sx={{ overflowX: "auto" }}>
//           <TableContainer component={Paper} sx={{ marginTop: 2 }}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Booking Id</TableCell>
//                   <TableCell>Booking Date</TableCell>
//                   <TableCell>Booking Purpose</TableCell>
//                   <TableCell>Booking Time</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell sx={{ width: "15%" }}>Location</TableCell>
//                   <TableCell>User Name</TableCell>
//                   <TableCell>Pod title</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {loading
//                   ? [1, 2, 3, 4, 5].map((n) => (
//                       <TableRow key={n}>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                         <TableCell>
//                           <Skeleton />
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   : displayedBookings.map((pod) => (
//                       <TableRow key={pod._id}>
//                         <TableCell>{pod.podId}</TableCell>
//                         <TableCell>{formatDate(pod.bookingDate)}</TableCell>
//                         <TableCell>{pod.bookingPurpose || "N/A"}</TableCell>
//                         <TableCell>{`${formatTime(
//                           pod.startTime
//                         )} - ${formatTime(pod.endTime)}`}</TableCell>
//                         <TableCell>
//                           <Button
//                             variant="contained"
//                             color={
//                               pod.status === "Completed"
//                                 ? "success"
//                                 : pod.status === "Pending"
//                                 ? "primary"
//                                 : pod.status === "Processing"
//                                 ? "warning"
//                                 : "error"
//                             }
//                             sx={{ borderRadius: "20px" }}
//                           >
//                             {pod.status}
//                           </Button>
//                         </TableCell>
//                         <TableCell>
//                           {`${pod.locationDetails?.name}, ${pod.locationDetails?.Street}, ${pod.locationDetails?.city}, ${pod.locationDetails?.state}, ${pod.locationDetails?.country_code}, ${pod.locationDetails?.zip}`}
//                         </TableCell>{" "}
//                         <TableCell>
//                           {pod.userDetails?.firstname || "N/A"}
//                         </TableCell>
//                         {/* Display location */}
//                       </TableRow>
//                     ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Box>
//         <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
//           <Pagination
//             count={Math.ceil(podsData.length / itemsPerPage)}
//             page={page}
//             onChange={handlePageChange}
//             variant="outlined"
//             shape="rounded"
//           />
//         </Box>
//       </Box>
//     );
//   }
// };

// export default Booking;






import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Stack,
  Box,
  Typography,
  Skeleton,
  CircularProgress,
  Pagination,
} from "@mui/material";
import { CSVLink } from "react-csv";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useAuth } from "../context/Authcontext";
import NoAccess from "./NoAccess.jsx";
import {
  fetchAllBookings,
  fetchLocationById,
  fetchUserById,
} from "../api/api.js"; // Import fetchLocationById

const Booking = () => {
  const [podsData, setPodsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState(true);
  const [userVerified, setUserVerified] = useState(false);
  const { verifyUser } = useAuth();
  const [page, setPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page

  // const loadBookingsData = async () => {
  //   try {
  //     const data = await fetchAllBookings();
  //     const sortedData = data.sort(
  //       (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  //     );
  //     for (const pod of sortedData) {
  //       const locationData = await fetchLocationById(pod.location);
  //       pod.locationDetails = locationData;

  //       const userData = await fetchUserById(pod.user);
  //       pod.userDetails = userData;
  //     }
  //     setPodsData(sortedData);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     setLoading(false);
  //   }
  // };

  // const loadBookingsData = async () => {
  //   try {
  //     const data = await fetchAllBookings();
  //     const sortedData = data.sort(
  //       (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  //     );

  //     // For each pod, create promises for location and user fetches
  //     const podsWithDetailsPromises = sortedData.map(async (pod) => {
  //       const [locationData, userData] = await Promise.all([
  //         fetchLocationById(pod.location),
  //         fetchUserById(pod.user),
  //       ]);
  //       return {
  //         ...pod,
  //         locationDetails: locationData,
  //         userDetails: userData,
  //       };
  //     });

  //     // Wait for all promises to resolve
  //     const podsWithDetails = await Promise.all(podsWithDetailsPromises);

  //     setPodsData(podsWithDetails);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     setLoading(false);
  //   }
  // };

  const loadBookingsData = async () => {
  try {
    const data = await fetchAllBookings();
    const sortedData = data.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt) // Sort by createdAt to show the most recently created first
    );
    setPodsData(sortedData); // Use sortedData instead of data
    setLoading(false);
  } catch (error) {
    console.error("Error fetching data: ", error);
    setLoading(false);
  }
};


// const loadBookingsData = async () => {
//   try {
//     const data = await fetchAllBookings();
//     const sortedData = data.sort(
//       (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
//     );
//     console.log("sortedData", sortedData);

//     const userCache = {};
//     const locationCache = {};

//     const bookingsWithDetails = await Promise.all(
//       sortedData.map(async (pod) => {
//         if (!userCache[pod.user]) {
//           userCache[pod.user] = await fetchUserById(pod.user);
//         }
//         if (!locationCache[pod.location]) {
//           locationCache[pod.location] = await fetchLocationById(pod.location);
//         }

//         return {
//           ...pod,
//           userDetails: userCache[pod.user],
//           locationDetails: locationCache[pod.location],
//         };
//       })
//     );

//     setPodsData(bookingsWithDetails);
//     setLoading(false);
//   } catch (error) {
//     console.error("Error fetching data: ", error);
//     setLoading(false);
//   }
// };




  useEffect(() => {
    const effect = async () => {
      setVerifying(true);
      let res = await verifyUser(6);
      setUserVerified(res);
      setVerifying(false);
      if (res) {
        loadBookingsData();
      }
    };
    effect();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA", options);
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // 12-hour format requires hour 0 to be 12
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutes} ${ampm}`;
  };

  const headers = [
    { label: "Booking Id", key: "podId" },
    { label: "Booking Date", key: "bookingDate" },
    { label: "Booking Purpose", key: "bookingPurpose" },
    { label: "Start Time", key: "startTime" },
    { label: "Pod Name", key: "podTitle" },
    { label: "End Time", key: "endTime" },
    { label: "Status", key: "status" },
    { label: "Location", key: "locationName" }, // Add location to CSV headers
    { label: "User Name", key: "username" },
  ];

  const csvReport = {
    filename: "User_Bookings_Report.csv",
    headers: headers,
    data: podsData,
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const displayedBookings = podsData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  if (verifying) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!userVerified) {
    return <NoAccess />;
  } else {
    return (
      <Box sx={{ padding: "43px 5px" }}>
        <Typography
          variant="h5"
          fontWeight={"bold"}
          sx={{ marginBottom: 2, color: "#ED3327" }}
        >
          Bookings
        </Typography>
        <Stack justifyContent={"space-between"} direction={"row"}>
          <Stack direction={"row"}>
            <Button
              variant="contained"
              sx={{
                marginRight: 2,
                backgroundColor: "#ED3327",
                borderRadius: "20px",
                "&:hover": {
                  bgcolor: "#ED3327",
                },
              }}
            >
              All Bookings ({podsData.length})
            </Button>
          </Stack>
          <Stack direction={"row"} spacing={2}>
            <CSVLink {...csvReport} style={{ textDecoration: "none" }}>
              <Button variant="outlined" startIcon={<GetAppIcon />}>
                Download All
              </Button>
            </CSVLink>
          </Stack>
        </Stack>

        {/* Table Container with Horizontal Scroll */}
        <Box sx={{ overflow: "auto", maxHeight: "70vh" }}>
          <TableContainer component={Paper} sx={{ marginTop: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: "120px" }}>Booking Id</TableCell>
                  <TableCell sx={{ minWidth: "100px" }}>Booking Date</TableCell>
                  <TableCell sx={{ minWidth: "100px" }}>
                    Booking Purpose
                  </TableCell>
                  <TableCell sx={{ minWidth: "150px" }}>Booking Time</TableCell>
                  <TableCell sx={{ minWidth: "150px" }}>Pod Name</TableCell>
                  <TableCell sx={{ minWidth: "250px" }}>Location</TableCell>
                  <TableCell sx={{ minWidth: "150px" }}>User Name</TableCell>
                  <TableCell sx={{ minWidth: "120px" }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading
                  ? [1, 2, 3, 4, 5].map((n) => (
                      <TableRow key={n}>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                      </TableRow>
                    ))
                  : displayedBookings.map((pod) => (
                      <TableRow key={pod._id}>
                        <TableCell>{pod._id}</TableCell>
                        <TableCell>{formatDate(pod.bookingDate)}</TableCell>
                        <TableCell>{pod.bookingPurpose || "N/A"}</TableCell>
                        <TableCell>{`${formatTime(
                          pod.startTime
                        )} - ${formatTime(pod.endTime)}`}</TableCell>
                        <TableCell>{pod.podTitle}</TableCell>

                        <TableCell>{`${pod.locationName}`}</TableCell>
                        <TableCell>{`${pod.username}`}</TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color={
                              pod.status === "Completed"
                                ? "success"
                                : pod.status === "Pending"
                                ? "primary"
                                : pod.status === "Processing"
                                ? "warning"
                                : "error"
                            }
                            sx={{ borderRadius: "20px" }}
                          >
                            {pod.status}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Pagination
            count={Math.ceil(podsData.length / itemsPerPage)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      </Box>
    );
  }
};

export default Booking;
